import { ChipList } from "@progress/kendo-react-buttons";
import { FieldRenderProps, FieldWrapper } from "@progress/kendo-react-form";
import { Error, Hint, Label } from "@progress/kendo-react-labels";
import { useRef } from "react";
import DisableableChiplistChip from "../utilities/DisableableChiplistChip";
import InfoIconAndTooltip from "../utilities/InfoIconAndTooltip";

export const FormChipList = (fieldRenderProps: FieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    wrapperStyle,
    onChange,
    value,
    tooltip,
    ...others
  } = fieldRenderProps;

  const editorRef = useRef<any>(null);

  const showValidationMessage: string | false | null = touched && validationMessage;
  const showHint: boolean = !showValidationMessage && hint;
  const hintId: string = showHint ? `${id}_hint` : "";
  const errorId: string = showValidationMessage ? `${id}_error` : "";
  const labelId: string = label ? `${id}_label` : "";

  const handleChangeOverride = (event: { target?: any; value?: any }) => {
    // disallow unselecting a chip. If selected chip is clicked again, event.value === null here
    // we want the chip to remain selected even if it is clicked again
    if (event.value) {
      onChange(event);
    }
  };

  return (
    <FieldWrapper style={wrapperStyle}>
      <div style={{ display: "flex", marginBottom: "8px" }}>
        <Label
          id={labelId}
          editorRef={editorRef}
          editorId={id}
          editorValid={valid}
          editorDisabled={disabled}
        >
          {label}
        </Label>
        {tooltip && <InfoIconAndTooltip>{tooltip}</InfoIconAndTooltip>}
      </div>
      <ChipList
        ariaLabelledBy={labelId}
        ariaDescribedBy={`${hintId} ${errorId}`}
        ref={editorRef}
        valid={valid}
        id={id}
        disabled={disabled}
        chip={DisableableChiplistChip}
        onChange={handleChangeOverride}
        value={value}
        {...others}
      />
      {showHint && <Hint id={hintId}>{hint}</Hint>}
      {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
    </FieldWrapper>
  );
};
